import { SET_MULTI_ACTION_CARD_SELECTED } from './actions';

const initialState = {
    selectedItem: 0
};

export default function multiActionsCard(state = initialState, { type, payload }) {
    switch (type) {
        case SET_MULTI_ACTION_CARD_SELECTED:
            return {
                ...state,
                selectedItem: payload
            };
        default:
            return state;
    }
}
